import { render } from "./QscChatbot.vue?vue&type=template&id=48cb20d8"
import script from "./QscChatbot.vue?vue&type=script&lang=js"
export * from "./QscChatbot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__